import { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { acceptInvite, verifyRegister } from '../core/_requests'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../core/Auth'
import SocialLoginButtons from '../components/SocialLoginButtons'
import TextInput from '../../widgets/components/Input/TextInput'
import { useIntl } from 'react-intl'
import { CustomToast } from '../../widgets/components/UI/CustomToast'
import { CustomButton } from '../../widgets/components/UI/CustomButton'
import { useNavigate } from 'react-router-dom'
import { getLocation } from '../../onboarding/core/_requests'
import { toast } from 'react-toastify'
import TagManager from 'react-gtm-module'
import axios from 'axios'
import { localeOptions } from '../../profile/core/_constants'
import { GTMEvent, updateUTMParameters } from '../../../hooks/gtmHelpers'
import { parseJsonString, removeNullFields } from '../../../core/_util'
import brandingConfig from '../../../../config/brandingConfig'
import { CookieComponent } from '../../../../_metronic/assets/ts/components/_CookieComponent'

export function Registration() {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const { saveAuth, setUserToken } = useAuth()
  const [errorsArray, setErrorsArray] = useState<string[]>()
  const [loading1, setLoading1] = useState(false)
  const [isInvited, setIsInvited] = useState<boolean>(false)
  const navigate = useNavigate()
  const IPSTACK_URL = `${process.env.REACT_APP_IPSTACK_LINK}?access_key=${process.env.REACT_APP_IPSTACK_ACCESS_KEY}&format=1`
  const [ipStackData, setIpStackData] = useState<any>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const eo = searchParams.get('eo')
  const { state, search } = useLocation() as any
  const isValidBoolean = eo === 'true' || eo === 'false'

  if (eo !== null && isValidBoolean) {
    localStorage.setItem('eo', eo)
  } else {
    localStorage.removeItem('eo') // remove existing value, if any
  }

  const initialValues = {
    firstname: state ? state.firstName : '',
    lastname: state ? state.lastName : '',
    email: state ? state.email : '',
    password: '',
    acceptTerms: false,
    signUpCompany: state ? state.companyName : '',
  }
  const registrationSchema = Yup.object().shape({
    firstname: Yup.string()
      .min(3, formatMessage({ id: 'Minimum 3 characters' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'First name is required' })),
    email: Yup.string()
      .email(formatMessage({ id: 'Invalid email format' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Email is required' })),
    lastname: Yup.string()
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Last name is required' })),
    password: Yup.string()
      .min(6, formatMessage({ id: 'Minimum 6 characters' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,50}$/,    
        'Password must be at least 8 characters long, and include at least 1 number and 1 special symbol'
      )
      .required(formatMessage({ id: 'Password is required' })),
    acceptTerms: Yup.bool(),
    signUpCompany: Yup.string()
      .min(3, formatMessage({ id: 'Minimum 3 characters' }))
      .max(50, formatMessage({ id: 'Maximum 50 characters' }))
      .required(formatMessage({ id: 'Company name is required' })),
  })

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmSource = urlParams.get('utm_source')
    const utmMedium = urlParams.get('utm_medium')
    const utmCampaign = urlParams.get('utm_campaign')
    const utmContent = urlParams.get('utm_content')
    const utmTerm = urlParams.get('utm_term')
    const gclid = urlParams.get('gclid')

    // Update UTM parameters
    if (utmSource) updateUTMParameters('utm_source', utmSource)
    if (utmMedium) updateUTMParameters('utm_medium', utmMedium)
    if (utmCampaign) updateUTMParameters('utm_campaign', utmCampaign)
    if (utmContent) updateUTMParameters('utm_content', utmContent)
    if (utmTerm) updateUTMParameters('utm_term', utmTerm)
    if (gclid) updateUTMParameters('rk_gclid', gclid)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const cookieFpromTid = CookieComponent.get('_fprom_tid') || '' // reading cookie here
  const cookieFpromRef = CookieComponent.get('_fprom_ref') || '' // reading cookie here

  useEffect(() => {
    const fetchIpStackData = async () => {
      try {
        const ipStackData = await getLocation()
        setIpStackData(ipStackData.data)
      } catch (err) {
        console.log(err)
      }
    }
    fetchIpStackData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // set referral
  const referral = new URL(window.location.href).searchParams.get('r') || null
  const lsReferral = localStorage.getItem('referral')
  if (!lsReferral?.length) {
    localStorage.setItem('referral', referral || '')
  }

  const invite = new URL(window.location.href).searchParams.get('invite')
  if (invite) {
    localStorage.setItem('inviteCode', invite)
  }

  const localStorageUtmSource = localStorage.getItem('utm_source') || ''
  const localStorageUtmMedium = localStorage.getItem('utm_medium') || ''
  const localStorageUtmCampaign = localStorage.getItem('utm_campaign') || ''
  const localStorageReferral = localStorage.getItem('referral') || ''
  const localStorageUtmContent = localStorage.getItem('utm_content') || ''
  const localStorageUtmTerm = localStorage.getItem('utm_term') || ''
  const localStorageGclid = localStorage.getItem('rk_gclid') || ''

  const formatUTCOffset = (dateString: string) => {
    if (dateString) {
      // Extract the GMT offset from the date string
      const gmtOffset = dateString?.substring(dateString.lastIndexOf('+') + 1)

      // Format the UTC offset into the desired format (UTC+HH:mm)
      const sign = gmtOffset?.startsWith('-') ? '-' : '+'
      const offsetParts = gmtOffset?.split(':')
      const hours = offsetParts[0]?.replace(sign, '')?.padStart(2, '0')
      const minutes = offsetParts[1]?.padStart(2, '0')

      const formattedOffset = `UTC${sign}${hours}:${minutes}`
      return formattedOffset
    }
  }

  const onSubmit = async (
    values: any,
    setSubmitting: (isSubmitting: boolean) => void,
    resetForm: any
  ) => {
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.SignupInitiatedSuccessful,
        signup_method: 'Email',
        metadata: removeNullFields({
          email: values.email,
          first_name: values.firstname,
          last_name: values.lastname,
          utm_source: parseJsonString(localStorageUtmSource),
          utm_medium: parseJsonString(localStorageUtmMedium),
          utm_campaign: parseJsonString(localStorageUtmCampaign),
          utm_content: parseJsonString(localStorageUtmContent),
          utm_term: parseJsonString(localStorageUtmTerm),
          gclid: parseJsonString(localStorageGclid),
          country_name: ipStackData?.country_name || 'NA',
          region_name: ipStackData?.region_name || 'NA',
          city_name: ipStackData?.city || 'NA',
          postcode: ipStackData?.zip || 111111,
        }),
      },
    })

    setLoading(true)
    try {
      const locationApiData = await axios.get<any, any>(IPSTACK_URL)
      // Safely accessing the first language code or falling back to a default if not present
      const firstLanguageCode = locationApiData?.data?.location?.languages?.[0]?.code || 'en'

      // Determining the locale based on the language code
      const locale =
        localeOptions?.find((o: any) => o.value.split('_')[0] === firstLanguageCode)?.value ||
        'en_US'

      const {
        data: { data, success, errors },
      } = await verifyRegister(
        values.email,
        values.firstname,
        values.lastname,
        values.password,
        localStorageUtmSource,
        localStorageUtmMedium,
        localStorageUtmCampaign,
        localStorageUtmContent,
        localStorageUtmTerm,
        localStorageGclid,
        localStorageReferral,
        locale,
        'MMM DD, YYYY',
        'hh:mm:ss a',
        formatUTCOffset(locationApiData?.data?.time_zone?.current_time) || 'UTC-05:00',
        locationApiData?.data?.country_code || 'US',
        locationApiData?.data?.region_code || 'NY',
        locationApiData?.data?.city || 'Manhattan',
        +locationApiData?.data?.zip || 10020,
        values.signUpCompany,
        cookieFpromTid,
        cookieFpromRef
      )

      if (success) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.EmailVerificationStartSuccessful,
            signup_method: 'Email',
            metadata: removeNullFields({
              email: values.email,
              method: 'normal',
              name: `${values?.firstname ?? ''} ${values?.lastname ?? ''}`,
              first_name: values?.firstname || '',
              last_name: values?.lastname || '',
              user_hash: values?.user_hash || null,
              signup_timestamp: new Date(data?.createdAt).getTime() / 1000,
              utm_source: parseJsonString(localStorageUtmSource),
              utm_medium: parseJsonString(localStorageUtmMedium),
              utm_campaign: parseJsonString(localStorageUtmCampaign),
              utm_content: parseJsonString(localStorageUtmContent),
              utm_term: parseJsonString(localStorageUtmTerm),
              gclid: parseJsonString(localStorageGclid),
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
            }),
          },
        })

        localStorage.setItem('email', values.email)

        setSubmitting(false)
        setLoading(false)
        resetForm()
        toast.success(formatMessage({ id: data.message }))
        navigate(`/auth/verify-otp/${data.userId}`)
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SignupFailed,
            signup_method: 'Email',
            email: `${values.email}`,
            metadata: removeNullFields({
              email: `${values?.email}`,
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
            }),
          },
        })
        if (errors[0].toString() === 'User already exists') {
          setErrorsArray([
            formatMessage({
              id: 'A user with this email already exists. Please log in to continue.',
            }),
          ])
        }
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
          setSubmitting(false)
          setLoading(false)
        })
      }
    } catch (error) {
      console.error(error)

      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SignupInitiatedFailed,
          signup_method: 'Email',
          metadata: removeNullFields({
            email: values.email,
            first_name: values.firstname,
            last_name: values.lastname,
            country_name: ipStackData?.country_name || 'NA',
            region_name: ipStackData?.region_name || 'NA',
            city_name: ipStackData?.city || 'NA',
            postcode: ipStackData?.zip || 111111,
            error: error,
          }),
        },
      })
    } finally {
      setSubmitting(false)
      setLoading(false)
    }
  }

  useEffect(() => {
    const setPlanData = async () => {
      try {
        const {
          data: {
            currency: { code },
          },
        } = await getLocation()
        const params = new URLSearchParams(search)
        const planName = params.get('plan')
        const allPlans = [
          'Basic-USD-Monthly',
          'Silver-USD-Monthly',
          'Gold-USD-Monthly',
          'Platinum-USD-Monthly',
          'Basic-INR-Monthly',
          'Silver-INR-Monthly',
          'Gold-INR-Monthly',
          'Platinum-INR-Monthly',
          'Basic-USD-Yearly',
          'Silver-USD-Yearly',
          'Gold-USD-Yearly',
          'Platinum-USD-Yearly',
          'Basic-INR-Yearly',
          'Silver-INR-Yearly',
          'Gold-INR-Yearly',
          'Platinum-INR-Yearly',
        ]
        if (planName && allPlans.includes(planName)) {
          localStorage.setItem('plan', planName)
        } else {
          if (code === 'INR') {
            localStorage.setItem('plan', 'Gold-USD-Monthly')
          } else {
            localStorage.setItem('plan', 'Gold-USD-Monthly')
          }
        }
      } catch (err) {
        const params = new URLSearchParams(search)
        const planName = params.get('plan')
        const allPlans = [
          'Basic-USD-Monthly',
          'Silver-USD-Monthly',
          'Gold-USD-Monthly',
          'Platinum-USD-Monthly',
          'Basic-INR-Monthly',
          'Silver-INR-Monthly',
          'Gold-INR-Monthly',
          'Platinum-INR-Monthly',
          'Basic-USD-Yearly',
          'Silver-USD-Yearly',
          'Gold-USD-Yearly',
          'Platinum-USD-Yearly',
          'Basic-INR-Yearly',
          'Silver-INR-Yearly',
          'Gold-INR-Yearly',
          'Platinum-INR-Yearly',
        ]
        if (planName && allPlans.includes(planName)) {
          localStorage.setItem('plan', planName)
        } else {
          localStorage.setItem('plan', 'Gold-USD-Monthly')
        }
      }
    }
    setPlanData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const handleAcceptInvite = async (
    values: any,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    setLoading(true)
    const locationApiData = await axios.get<any, any>(IPSTACK_URL)
    const firstLanguageCode = locationApiData?.data?.location?.languages?.[0]?.code || 'en'
    const locale =
      localeOptions?.find((o: any) => o.value.split('_')[0] === firstLanguageCode)?.value || 'en_US'
    try {
      const {
        data: { data: token, success, errors, data },
      } = await acceptInvite(state.inviteToken,
        values.password,
        locale,
        'MMM DD, YYYY',
        'hh:mm:ss a',
        formatUTCOffset(locationApiData?.data?.time_zone?.current_time) || 'UTC-05:00')

      if (success) {
        navigate('/auth/verify-phone')
        await saveAuth(token)
        setUserToken(data.token)
        navigate('/auth/verify-phone')
      } else {
        setErrorsArray(errors)
        await saveAuth(undefined)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setSubmitting(false)
      setLoading(false)
    }
  }

  return (
    <>
      {' '}
      <Formik
        initialValues={initialValues}
        validationSchema={registrationSchema}
        onSubmit={(values, { resetForm, setSubmitting }) => {
          isInvited
            ? handleAcceptInvite(values, setSubmitting)
            : onSubmit(values, setSubmitting, resetForm)
        }}
        validateOnMount
      >
        {(formik) => {
          if (state) {
            initialValues.firstname = state.firstName
            initialValues.lastname = state.lastName
            initialValues.email = state.email
            setIsInvited(true)
          }
          return (
            <Form
              className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework px-3'
              id='kt_login_signup_form'
            >
              {/* begin::Heading */}
              <div className='text-center mb-11'>
                <h1 className='text-dark fw-bolder mb-3'>
                  {formatMessage({ id: `Sign Up to ${brandingConfig.brandName}` })}
                </h1>
                <div className='text-gray-500 text-center fw-bold fs-4'>
                  {formatMessage({ id: 'Already have an account?' })}{' '}
                  <Link to='/auth/login/' className='link-primary fw-bold fs-4'>
                    {formatMessage({ id: 'Sign In' })}
                  </Link>
                </div>
              </div>
              {/* begin::Heading */}

              <div className=' mb-9'>
                <SocialLoginButtons
                  disable={loading}
                  loading1={loading1}
                  setLoading1={setLoading1}
                />
                {/* begin::Separator */}
                <div className='separator separator-content my-14'>
                  <span className='  fw-semibold fs-6 text-uppercase'>
                    {formatMessage({ id: 'Or' })}
                  </span>
                </div>
                {/* end::Separator */}
              </div>

              {errorsArray?.map((error: string) => (
                <CustomToast className='mb-lg-15' status={error} />
              ))}
              {formik.status && <CustomToast className='mb-lg-15' status={formik.status} />}

              <div>
                <div className='row'>
                  <div className='col-md-6 col-12'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'First Name' })}
                      fieldName={'firstname'}
                      formik={formik}
                      placeholder=''
                      toolTipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.REGISTRATION.FIRST_NAME',
                      })}
                      isWidthNotRequired={true}
                      isDisabled={isInvited || loading}
                      isStarRequired={true}
                      onBlur={formik.handleBlur}
                      margin='me-0'
                    />
                  </div>
                  <div className='col-md-6 col-12'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Last Name' })}
                      fieldName={'lastname'}
                      formik={formik}
                      placeholder=''
                      toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.REGISTRATION.LAST_NAME' })}
                      isWidthNotRequired={true}
                      margin={'me-0'}
                      isDisabled={isInvited || loading}
                      isStarRequired={true}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>

                {/* begin::Form group */}
                <TextInput
                  fieldType={'email'}
                  fieldName={'email'}
                  formik={formik}
                  placeholder={''}
                  label={formatMessage({ id: 'Email' })}
                  toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.REGISTRATION.EMAIL' })}
                  isDisabled={isInvited || loading}
                  isStarRequired={true}
                  onBlur={formik.handleBlur}
                />
                {/* end::Form group */}

                {/* begin::Form group */}
                <TextInput
                  fieldType={'text'}
                  label={formatMessage({ id: 'Company Name' })}
                  fieldName={'signUpCompany'}
                  formik={formik}
                  placeholder=''
                  toolTipText={formatMessage({
                    id: 'GLOBAL.TOOLTIP.REGISTRATION.SUGNUP_COMPANY',
                  })}
                  isWidthNotRequired={true}
                  isDisabled={isInvited || loading}
                  isStarRequired={true}
                  onBlur={formik.handleBlur}
                  margin='me-0'
                />
                <TextInput
                  fieldType={'text'}
                  fieldName={'password'}
                  isPassword={true}
                  formik={formik}
                  placeholder={''}
                  label={formatMessage({ id: 'Password' })}
                  toolTipText={formatMessage({ id: 'GLOBAL.TOOLTIP.REGISTRATION.PASSWORD' })}
                  isStarRequired={true}
                  isDisabled={loading}
                  onBlur={formik.handleBlur}
                />
                {/* end::Form group */}

                <TextInput
                  fieldName={'acceptTerms'}
                  formik={formik}
                  linkText1={formatMessage({ id: 'Terms of use' })}
                  linkText2={formatMessage({ id: 'Privacy Policy' })}
                  url1={brandingConfig.termsUrl}
                  url2={brandingConfig.privacyUrl}
                  customText={formatMessage({ id: 'I Agree' })}
                  placeholder=''
                  fieldType={'checkbox'}
                  isCheckbox={true}
                  isDisabled={loading}
                  isTooltipNotRequired
                  onBlur={formik.handleBlur}
                  isLabelNone
                />
              </div>
              {/* begin::Form group */}
              {/* begin::Action */}
              <CustomButton
                isSubmitting={formik.isSubmitting}
                isValid={formik.isValid}
                isAcceptTerms={formik.values.acceptTerms}
                buttonText={formatMessage({ id: 'Sign Up Now' })}
                loading={loading}
                isAcceptTermsPresent={true}
                disable={loading1}
              />
              {/* end::Action */}
              {/* end::Form group */}
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
